import { assign, entryId } from "../../helper.js";
import { isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/tableColumn.entity.js
var createColumn = () => ({
	id: "",
	tableId: "",
	name: "",
	comment: "",
	dataType: "",
	default: "",
	options: 0,
	logicalName: "",
	domainId: "",
	ui: {
		keys: 0,
		widthName: 60,
		widthLogicalName: 60,
		widthComment: 60,
		widthDataType: 60,
		widthDomain: 60,
		widthDefault: 60
	}
});
function createAndMergeTableColumnEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createColumn();
		const assignString = assign(isString, target, value);
		const assignNumber = assign(isNumber, target, value);
		const uiAssignNumber = assign(isNumber, target.ui, value.ui);
		target.id = entryId(key, value);
		assignString("tableId");
		assignString("name");
		assignString("comment");
		assignString("dataType");
		assignString("default");
		assignNumber("options");
		assignString("logicalName");
		assignString("domainId");
		uiAssignNumber("keys");
		uiAssignNumber("widthName");
		uiAssignNumber("widthLogicalName");
		uiAssignNumber("widthComment");
		uiAssignNumber("widthDataType");
		uiAssignNumber("widthDomain");
		uiAssignNumber("widthDefault");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeTableColumnEntities, createColumn };
